// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1145541a","divider":"_d0bcff3e","column":"_934da7e9","row":"_cc8f6335","cell":"_b7446719","appStoreLink":"_4b08f141"};